// extracted by mini-css-extract-plugin
export default {"list_second_level_padding_left":"40px","list_third_level_padding_left":"80px"};